import styled from '@emotion/styled'
import {
  Checkbox,
  FormControl,
  Icon,
  InputLabel,
  ListItemText,
  MenuItem,
  SelectMultipleProps,
  theme,
} from '@yuno/design-system-web'
import { useContext, useEffect, useState } from 'react'
import { FiltersContext } from '../../context/filters-context'
import { MenuProps } from '../../utils/constants'
import { AlternativeTextTypoSelect, StyledSelect } from './styles'
import { selectRender } from '../../utils/selectRender'
import { useClearFilterEvent } from '@yuno/dashboard-container-mfe'
import { useTranslation } from 'react-i18next'

export const Wrapper = styled.div`
  width: 220px;
`

export default function CategoryTypeFilter() {
  const {
    handleSetFilter,
    filter: { categoryType },
    handleResetFilters,
  } = useContext(FiltersContext)
  const { t } = useTranslation()

  const options = ['Fraud Solution', 'Payment Method', 'Processor']
  const [allOptionsSelected, useAllOptionsSelected] = useState(true)
  const [noneSelected, useNoneSelected] = useState(true)

  useClearFilterEvent(() => {
    handleResetFilters()
    useAllOptionsSelected(true)
    useNoneSelected(true)
  })

  const handleChange = (event) => {
    const {
      target: { value },
    } = event
    useAllOptionsSelected(value?.length === options?.length)
    useNoneSelected(value?.length === 0)

    handleSetFilter(
      'categoryType',
      typeof value === 'string' ? value.split(',') : value,
    )
  }

  useEffect(() => {
    useAllOptionsSelected(categoryType?.length === options?.length)
    useNoneSelected(categoryType?.length === 0)
  }, [])

  const handleRenderValue = (selected: SelectMultipleProps['value']) => {
    return selectRender(selected, options)
  }

  return (
    <Wrapper>
      <InputLabel id="multiple-checkbox-label">
        {t('categoryType')}
      </InputLabel>
      <FormControl fullWidth style={{ position: 'relative' }}>
        <StyledSelect
          multiple
          displayEmpty
          value={categoryType}
          onChange={handleChange}
          renderValue={handleRenderValue}
          MenuProps={MenuProps}
          IconComponent={(props) => (
            <Icon name="CaretDown" weight="bold" {...props} />
          )}
        >
          {options.map((name) => (
            <MenuItem
              style={{
                backgroundColor: theme.palette.neutral.white[0],
                color: theme.palette.neutral.black,
              }}
              key={name}
              value={name}
            >
              <Checkbox checked={categoryType.indexOf(name) > -1} />
              <ListItemText primary={name} />
            </MenuItem>
          ))}
        </StyledSelect>
      </FormControl>
    </Wrapper>
  )
}

CategoryTypeFilter.defaultProps = { headerComponent: true }
